import i18next from 'i18next';

export const translate = (msg = '', options) => (i18next.t(msg, options));

export const translateError = (code, options) =>
  translate(`errors.${code}`, options) || translate('errors.UNKNOWN_ERROR', options);

export const translateCombinedError = (msg, code, options) =>
  `${translate(msg, options)}: ${translateError(code, options)}`;